module.exports = __webpack_public_path__ + "img/img-1-mobile.7c0ca227.webp";